import { Route, Routes } from 'react-router-dom';
import Main from './layout/Main';
import Login from './pages/login';
import SignUpPage from './pages/signup';
import { LightTheme } from './LightTheme';
import { ThemeProvider } from '@mui/material/styles';
import './App.css';
import "leaflet/dist/leaflet.css";
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import SOSAlertDialog from '../src/pages/widget/SOSAlertDialog';

function App() {
  const token = localStorage.getItem("token");

  return (
    <>
      <div className="App">
        <ToastContainer />
        <ThemeProvider theme={LightTheme}>
          {/* 🔥 GLOBAL SOS ALERT POPUP HERE */}
          {token && <SOSAlertDialog />}
          <Routes>
            <Route path="*" name="Home" element={<Main />} />
            <Route path="/" exact element={<Login />} />
            <Route path="/signup" exact element={<SignUpPage />} />
          </Routes>
        </ThemeProvider>
      </div>
    </>
  );
}

export default App;
